import React from 'react';
import { Target, Heart, Users, Book } from 'lucide-react';

const About = () => {
  return (
    <div className="page-container about-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="page-hero-bg" 
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1565813086292-604790c8a97b?w=1920)' }}
        >
          <div className="page-hero-overlay" />
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">About United Christian Fellowship</h1>
          <p className="page-hero-subtitle">
            Building unity in the body of Christ across churches and nations
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="content-section">
        <div className="container">
          {/* Our Story */}
          <div className="about-section">
            <h2 className="section-title">Our Story</h2>
            <div className="section-content">
              <p>
                United Christian Fellowship was born out of a vision to see churches and believers 
                unite beyond denominational walls. We believe that when God's people come together 
                in unity, powerful transformation happens in communities and nations.
              </p>
              <p>
                Based in Edmonton, Alberta, we bring together Christians from diverse backgrounds 
                to worship, learn, and serve together. Through conferences, worship festivals, and 
                fellowship gatherings, we create spaces where believers can encounter God's presence 
                and grow in their faith.
              </p>
            </div>
          </div>

          {/* Our Mission & Values */}
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <Target size={32} />
              </div>
              <h3>Our Mission</h3>
              <p>
                To unite churches and believers across denominational lines, fostering spiritual 
                growth, authentic worship, and community transformation through the power of Christ.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Heart size={32} />
              </div>
              <h3>Our Heart</h3>
              <p>
                We are passionate about seeing believers walk in unity, experiencing the fullness 
                of God's presence, and making a lasting impact in their communities.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Users size={32} />
              </div>
              <h3>Our Community</h3>
              <p>
                We celebrate diversity within the body of Christ and believe that every believer 
                has a vital role to play in God's kingdom work.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Book size={32} />
              </div>
              <h3>Our Foundation</h3>
              <p>
                We are firmly rooted in Scripture, believing the Bible is God's inspired Word 
                and the ultimate authority for faith and life.
              </p>
            </div>
          </div>

          {/* What We Do */}
          <div className="about-section">
            <h2 className="section-title">What We Do</h2>
            <div className="activities-grid">
              <div className="activity-item">
                <h4>Worship & Music Festivals</h4>
                <p>
                  Large-scale worship gatherings that bring believers together for powerful 
                  encounters with God through music and praise.
                </p>
              </div>
              <div className="activity-item">
                <h4>Conferences & Conventions</h4>
                <p>
                  Teaching conferences featuring renowned speakers and church leaders who equip 
                  believers for ministry and life.
                </p>
              </div>
              <div className="activity-item">
                <h4>Prayer Gatherings</h4>
                <p>
                  Corporate prayer meetings where we intercede for revival, transformation, 
                  and breakthrough in our cities.
                </p>
              </div>
              <div className="activity-item">
                <h4>Leadership Development</h4>
                <p>
                  Training and mentoring programs that equip the next generation of church 
                  leaders with vision and wisdom.
                </p>
              </div>
              <div className="activity-item">
                <h4>Community Outreach</h4>
                <p>
                  Practical initiatives that demonstrate God's love through service and 
                  compassion in our communities.
                </p>
              </div>
              <div className="activity-item">
                <h4>Youth & Family Ministry</h4>
                <p>
                  Programs and events specifically designed to engage young people and 
                  strengthen families in faith.
                </p>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="about-cta">
            <h2>Join Us in Building Unity</h2>
            <p>
              Be part of a movement that's bringing churches together and transforming 
              communities through the power of Christ.
            </p>
            <div className="cta-buttons">
              <a href="/events" className="btn btn-primary">
                Attend an Event
              </a>
              <a href="/contact" className="btn btn-secondary">
                Get in Touch
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
